import SelectAppointmentCampaignPage from "./SelectAppointmentCampaignPage";

export default SelectAppointmentCampaignPage;

export * from "./SelectAppointmentCampaignPage";
